import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CallingHangupIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingHangup",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.91 12.01c-.38-.17-.76-.33-1.17-.47-2.24-.81-4.82-1.27-7.51-1.27h-.24.01-.23c-2.69 0-5.27.47-7.66 1.32l.16-.05c-.95.34-1.75.72-2.51 1.16l.07-.04c-2.37 1.36-3.82 3.21-3.82 5.24v1.91c0 1.05.85 1.91 1.91 1.91h5.09c1.05 0 1.91-.85 1.91-1.91v-3.74c0-.7.57-1.26 1.27-1.27h7.64c.7 0 1.27.57 1.27 1.27v3.74c0 1.06.85 1.92 1.91 1.92h5.1c1.05 0 1.91-.85 1.91-1.91V17.9c0-2.37-1.99-4.49-5.09-5.89Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29 21.13h-7.22c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1h-7.56c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h6.22v-1c0-1.65 1.35-3 3-3h7.56c1.65 0 3 1.35 3 3v1H28V17c0-2.76-2.24-5-5-5H9a5.03 5.03 0 0 0-4.95 4.27c-.08.55-.6.92-1.13.85-.55-.08-.92-.59-.85-1.13.5-3.41 3.47-5.98 6.93-5.98h14c3.86 0 7 3.14 7 7v3.13c0 .55-.45 1-1 1Z"
      })
    })
  }));
};